import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLenis } from "lenis/react";
import { Reveal } from "@/components/Reveal";

const pillStyles = {
  solid: "bg-primary text-primary-foreground hover:scale-[1.04]",
  dark: "bg-accent text-accent-foreground hover:scale-[1.04]",
  outline: "border border-foreground/25 text-foreground hover:bg-accent hover:text-accent-foreground hover:border-accent",
};

export const PillLink = ({ to, children, variant = "solid", testid, className = "" }) => {
  return (
    <Link
      to={to}
      data-testid={testid}
      className={`inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-sm sm:text-base font-semibold transition-transform duration-300 will-change-transform ${pillStyles[variant]} ${className}`}
    >
      {children}
      <ArrowUpRight size={18} />
    </Link>
  );
};

export const ScrollCTA = ({ targetId, children, variant = "solid", testid, className = "" }) => {
  const lenis = useLenis();
  const go = () => {
    const el = document.getElementById(targetId);
    if (!el) return;
    if (lenis) lenis.scrollTo(el, { offset: -30 });
    else el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <button
      type="button"
      onClick={go}
      data-testid={testid}
      className={`inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-sm sm:text-base font-semibold transition-transform duration-300 will-change-transform ${pillStyles[variant]} ${className}`}
    >
      {children}
      <ArrowUpRight size={18} />
    </button>
  );
};

export const Kicker = ({ children, className = "" }) => (
  <span className={`inline-block text-xs sm:text-sm font-semibold uppercase tracking-[0.28em] text-primary ${className}`}>
    {children}
  </span>
);

export const CTABand = () => (
  <section data-testid="cta-band" className="bg-primary text-primary-foreground">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 py-24 sm:py-32">
      <Reveal>
        <p className="text-sm uppercase tracking-[0.28em] opacity-80">Your next opportunity</p>
        <h2 className="font-display text-4xl sm:text-6xl lg:text-7xl tracking-mega leading-[0.9] mt-5 max-w-4xl">
          Don't Miss Out on Your FaeVor!
        </h2>
        <div className="mt-10 flex flex-wrap gap-4">
          <Link
            to="/contact"
            data-testid="cta-band-contact"
            className="inline-flex items-center gap-2 rounded-full bg-accent text-accent-foreground px-8 py-4 font-semibold transition-transform duration-300 hover:scale-[1.04]"
          >
            Talk With FaeVor Works <ArrowUpRight size={18} />
          </Link>
          <Link
            to="/real-estate"
            className="inline-flex items-center gap-2 rounded-full border border-primary-foreground/40 px-8 py-4 font-semibold transition-colors duration-300 hover:bg-primary-foreground hover:text-primary"
          >
            Explore Solutions
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);
